import React, { Component } from "react";
import PropTypes from "prop-types";
import {Graphics} from './components/Graphics';
import "./Transilluminator.scss";


export class Transilluminator extends Component {

  
  componentWillMount() {
    this.props.createTransilluminator({
      props: this.props.defaultProps,
    });
  }

  toggleToolTipControls = (showControls) => {
    this.props.toggleToolTipControls({
      id: this.props.id,
      showToolTipControls: showControls
    })
  }

  render() {
    const open = this.props.open ? 'open' : '';
    return (
      <ul>
        <li
          aria-label="Transilluminator"
          id="Transilluminator"
          className={"dropTarget Transilluminator "+ open }
        >
          <p aria-hidden="true" className="label" style={{display:"none"}}>{this.props.type}</p>
          <div
            onMouseEnter={()=>this.toggleToolTipControls(true)}
            onMouseLeave={()=>this.toggleToolTipControls(false)}
          >
            <Graphics id={this.props.id} />
          </div>
        </li>
      </ul>
    );
  }
}


Transilluminator.propTypes = {
  createTransilluminator: PropTypes.func,
};

Transilluminator.defaultProps = {};
